
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const UserRole = {
  PLAYER: 'PLAYER',
  SUPPORT: 'SUPPORT',
  ADMIN: 'ADMIN',
  AGENT_MANAGER_ADMIN: 'AGENT_MANAGER_ADMIN',
  DEV: 'DEV',
  SUPER_ADMIN: 'SUPER_ADMIN'
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]


export const TableType = {
  CASH: 'CASH',
  TOURNAMENT: 'TOURNAMENT',
  SNG: 'SNG'
} as const

export type TableType = (typeof TableType)[keyof typeof TableType]


export const PokerCategory = {
  Stud: 'Stud',
  Omaha: 'Omaha',
  Holdem: 'Holdem',
  Draw: 'Draw',
  Chinese: 'Chinese',
  Mixed: 'Mixed'
} as const

export type PokerCategory = (typeof PokerCategory)[keyof typeof PokerCategory]


export const TableStatus = {
  INITIALIZING: 'INITIALIZING',
  STOPPING: 'STOPPING',
  STOPPED: 'STOPPED',
  RESTARTING: 'RESTARTING',
  RUNNING: 'RUNNING'
} as const

export type TableStatus = (typeof TableStatus)[keyof typeof TableStatus]


export const SubmissionStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  ON_HOLD: 'ON_HOLD'
} as const

export type SubmissionStatus = (typeof SubmissionStatus)[keyof typeof SubmissionStatus]


export const TransactionType = {
  ADD_AUTO_TOP_UP: 'ADD_AUTO_TOP_UP',
  ADD_WHITELIST: 'ADD_WHITELIST',
  COLLECT_LEADERBOARD_PRIZE: 'COLLECT_LEADERBOARD_PRIZE',
  COLLECT_RAKE: 'COLLECT_RAKE',
  CREATE_TABLE: 'CREATE_TABLE',
  DEPOSIT_BONUS: 'DEPOSIT_BONUS',
  DISTRIBUTE_NET_RAKE: 'DISTRIBUTE_NET_RAKE',
  DISTRIBUTE_REVENUE: 'DISTRIBUTE_REVENUE',
  END_REWARDS_DISTRIBUTION: 'END_REWARDS_DISTRIBUTION',
  FUND_SATELLITE_TICKET_POOL: 'FUND_SATELLITE_TICKET_POOL',
  FUND_TABLE: 'FUND_TABLE',
  GRANT_INTERNAL_TOKEN_DEAL: 'GRANT_INTERNAL_TOKEN_DEAL',
  JOIN_TABLE: 'JOIN_TABLE',
  LEADERBOARD_PRIZE_PAYOUT: 'LEADERBOARD_PRIZE_PAYOUT',
  LEAVE_TABLE: 'LEAVE_TABLE',
  PAY_RAKE_SHARE: 'PAY_RAKE_SHARE',
  PAY_RAKE_SHARE_BATCH: 'PAY_RAKE_SHARE_BATCH',
  PAY_REWARDS: 'PAY_REWARDS',
  PHNM_REDEEMED: 'PHNM_REDEEMED',
  PLAYER_DEPOSIT: 'PLAYER_DEPOSIT',
  PLAYER_WITHDRAWAL: 'PLAYER_WITHDRAWAL',
  REBUY: 'REBUY',
  REBUY_REFUND: 'REBUY_REFUND',
  RECOVER_FUNDS: 'RECOVER_FUNDS',
  REFUND: 'REFUND',
  REMOVE_WHITELIST: 'REMOVE_WHITELIST',
  REVOKE_INTERNAL_TOKEN_DEAL: 'REVOKE_INTERNAL_TOKEN_DEAL',
  START_DISTRIBUTING_AGENT_RAKE: 'START_DISTRIBUTING_AGENT_RAKE',
  START_DISTRIBUTING_NET_RAKE: 'START_DISTRIBUTING_NET_RAKE',
  START_LEFTOVER_REVENUE_TRANSFER: 'START_LEFTOVER_REVENUE_TRANSFER',
  START_PHNM_PRICE_UPDATE: 'START_PHNM_PRICE_UPDATE',
  START_PHNM_TRANSFER: 'START_PHNM_TRANSFER',
  START_REVENUE_DISTRIBUTION: 'START_REVENUE_DISTRIBUTION',
  START_REWARDS_DISTRIBUTION: 'START_REWARDS_DISTRIBUTION',
  START_REWARDS_FUNDING: 'START_REWARDS_FUNDING',
  TABLE_REFUND: 'TABLE_REFUND',
  TOPUP_REFUND: 'TOPUP_REFUND',
  TOURNAMENT_CLOSE_REGISTRATION: 'TOURNAMENT_CLOSE_REGISTRATION',
  TOURNAMENT_COLLECT_RAKE: 'TOURNAMENT_COLLECT_RAKE',
  TOURNAMENT_DEPLOY: 'TOURNAMENT_DEPLOY',
  TOURNAMENT_ELIMINATE_PLAYER: 'TOURNAMENT_ELIMINATE_PLAYER',
  TOURNAMENT_END: 'TOURNAMENT_END',
  TOURNAMENT_EXTRACT_FUNDS: 'TOURNAMENT_EXTRACT_FUNDS',
  TOURNAMENT_FUND_PRIZE_POOL: 'TOURNAMENT_FUND_PRIZE_POOL',
  TOURNAMENT_PAUSE: 'TOURNAMENT_PAUSE',
  TOURNAMENT_PRIZE: 'TOURNAMENT_PRIZE',
  TOURNAMENT_RAKE_DISTRIBUTION: 'TOURNAMENT_RAKE_DISTRIBUTION',
  TOURNAMENT_REENTRY: 'TOURNAMENT_REENTRY',
  TOURNAMENT_REFUND: 'TOURNAMENT_REFUND',
  TOURNAMENT_REGISTRATION: 'TOURNAMENT_REGISTRATION',
  TOURNAMENT_REGISTRATION_WITH_TICKET: 'TOURNAMENT_REGISTRATION_WITH_TICKET',
  TOURNAMENT_START: 'TOURNAMENT_START',
  TOURNAMENT_UNPAUSE: 'TOURNAMENT_UNPAUSE',
  TOURNAMENT_UNREGISTRATION: 'TOURNAMENT_UNREGISTRATION',
  TRANSFER: 'TRANSFER',
  TRANSFER_BACKEND_TO_LEADERBOARD: 'TRANSFER_BACKEND_TO_LEADERBOARD',
  TRANSFER_BACKEND_TO_POOL: 'TRANSFER_BACKEND_TO_POOL',
  TRANSFER_BACKEND_TO_TICKET: 'TRANSFER_BACKEND_TO_TICKET',
  TRANSFER_BACKEND_TO_TOURNAMENT: 'TRANSFER_BACKEND_TO_TOURNAMENT',
  TRANSFER_LEADERBOARD_TO_BACKEND: 'TRANSFER_LEADERBOARD_TO_BACKEND',
  TRANSFER_LEADERBOARD_TO_POOL: 'TRANSFER_LEADERBOARD_TO_POOL',
  TRANSFER_LEADERBOARD_TO_TOURNAMENT: 'TRANSFER_LEADERBOARD_TO_TOURNAMENT',
  TRANSFER_LEFTOVER_REVENUE_TO_TREASURY: 'TRANSFER_LEFTOVER_REVENUE_TO_TREASURY',
  TRANSFER_PHNM_TO_TREASURY: 'TRANSFER_PHNM_TO_TREASURY',
  TRANSFER_POOL_TO_BACKEND: 'TRANSFER_POOL_TO_BACKEND',
  TRANSFER_POOL_TO_LEADERBOARD: 'TRANSFER_POOL_TO_LEADERBOARD',
  TRANSFER_POOL_TO_PLAYER: 'TRANSFER_POOL_TO_PLAYER',
  TRANSFER_POOL_TO_TICKET: 'TRANSFER_POOL_TO_TICKET',
  TRANSFER_POOL_TO_TOURNAMENT: 'TRANSFER_POOL_TO_TOURNAMENT',
  TRANSFER_TICKET_TO_BACKEND: 'TRANSFER_TICKET_TO_BACKEND',
  TRANSFER_TICKET_TO_POOL: 'TRANSFER_TICKET_TO_POOL',
  TRANSFER_TOURNAMENT_DOLLARS_TO_USER: 'TRANSFER_TOURNAMENT_DOLLARS_TO_USER',
  TRANSFER_TOURNAMENT_TO_BACKEND: 'TRANSFER_TOURNAMENT_TO_BACKEND',
  TRANSFER_TOURNAMENT_TO_LEADERBOARD: 'TRANSFER_TOURNAMENT_TO_LEADERBOARD',
  TRANSFER_TOURNAMENT_TO_POOL: 'TRANSFER_TOURNAMENT_TO_POOL',
  TRANSFER_TOURNAMENT_TO_TICKET: 'TRANSFER_TOURNAMENT_TO_TICKET',
  UPDATE_PHNM_PRICE: 'UPDATE_PHNM_PRICE',
  USDT_APPROVE: 'USDT_APPROVE',
  USDT_APPROVE_TICKET: 'USDT_APPROVE_TICKET',
  USDT_TRANSFER: 'USDT_TRANSFER'
} as const

export type TransactionType = (typeof TransactionType)[keyof typeof TransactionType]


export const TransactionStatus = {
  CONFIRMED: 'CONFIRMED',
  DUPLICATED: 'DUPLICATED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  PERMANENTLY_FAILED: 'PERMANENTLY_FAILED',
  RESOLVED: 'RESOLVED',
  REVERTED: 'REVERTED'
} as const

export type TransactionStatus = (typeof TransactionStatus)[keyof typeof TransactionStatus]


export const FriendRequestStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED'
} as const

export type FriendRequestStatus = (typeof FriendRequestStatus)[keyof typeof FriendRequestStatus]


export const LeaderboardType = {
  MICRO: 'MICRO',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
} as const

export type LeaderboardType = (typeof LeaderboardType)[keyof typeof LeaderboardType]


export const DealType = {
  OVERRIDE: 'OVERRIDE',
  FLAT: 'FLAT'
} as const

export type DealType = (typeof DealType)[keyof typeof DealType]


export const AgentAssociationMigrationBatchStatus = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed'
} as const

export type AgentAssociationMigrationBatchStatus = (typeof AgentAssociationMigrationBatchStatus)[keyof typeof AgentAssociationMigrationBatchStatus]


export const AgentAssociationMigrationUserStatus = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed'
} as const

export type AgentAssociationMigrationUserStatus = (typeof AgentAssociationMigrationUserStatus)[keyof typeof AgentAssociationMigrationUserStatus]


export const ReferralRakeShareMigrationStatus = {
  pending: 'pending',
  in_progress: 'in_progress',
  completed: 'completed',
  failed: 'failed',
  not_applicable: 'not_applicable'
} as const

export type ReferralRakeShareMigrationStatus = (typeof ReferralRakeShareMigrationStatus)[keyof typeof ReferralRakeShareMigrationStatus]


export const TournamentType = {
  STANDARD: 'STANDARD',
  SNG: 'SNG'
} as const

export type TournamentType = (typeof TournamentType)[keyof typeof TournamentType]


export const TournamentStatus = {
  CREATED: 'CREATED',
  INITIALIZING: 'INITIALIZING',
  RUNNING: 'RUNNING',
  BREAK: 'BREAK',
  RESTARTING: 'RESTARTING',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
} as const

export type TournamentStatus = (typeof TournamentStatus)[keyof typeof TournamentStatus]


export const PayoutStructureType = {
  STANDARD: 'STANDARD',
  SATELITE: 'SATELITE'
} as const

export type PayoutStructureType = (typeof PayoutStructureType)[keyof typeof PayoutStructureType]


export const TournamentRecurringType = {
  NONE: 'NONE',
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY'
} as const

export type TournamentRecurringType = (typeof TournamentRecurringType)[keyof typeof TournamentRecurringType]


export const TournamentTicketStatus = {
  PENDING: 'PENDING',
  AVAILABLE: 'AVAILABLE',
  REDEEMED: 'REDEEMED'
} as const

export type TournamentTicketStatus = (typeof TournamentTicketStatus)[keyof typeof TournamentTicketStatus]


export const TournamentDollarLedgerType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT'
} as const

export type TournamentDollarLedgerType = (typeof TournamentDollarLedgerType)[keyof typeof TournamentDollarLedgerType]


export const TournamentEventType = {
  LEVEL_START: 'LEVEL_START',
  LEVEL_END: 'LEVEL_END',
  TOURNAMENT_BREAK_START: 'TOURNAMENT_BREAK_START',
  TOURNAMENT_BREAK_END: 'TOURNAMENT_BREAK_END',
  REGISTRATION_OPEN: 'REGISTRATION_OPEN',
  REGISTRATION_CLOSE: 'REGISTRATION_CLOSE',
  PLAYER_REGISTERED: 'PLAYER_REGISTERED',
  TOURNAMENT_PLAYER_ELIMINATED: 'TOURNAMENT_PLAYER_ELIMINATED',
  PLAYER_REBUY: 'PLAYER_REBUY',
  PLAYER_ADDON: 'PLAYER_ADDON',
  TOURNAMENT_START: 'TOURNAMENT_START',
  TOURNAMENT_PAUSE: 'TOURNAMENT_PAUSE',
  TOURNAMENT_TABLE_PAUSE: 'TOURNAMENT_TABLE_PAUSE',
  TOURNAMENT_RESUME: 'TOURNAMENT_RESUME',
  TOURNAMENT_END: 'TOURNAMENT_END',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  TOURNAMENT_HAND_BY_HAND_MODE_ENABLED: 'TOURNAMENT_HAND_BY_HAND_MODE_ENABLED',
  TOURNAMENT_HAND_BY_HAND_MODE_DISABLED: 'TOURNAMENT_HAND_BY_HAND_MODE_DISABLED',
  TOURNAMENT_CANCEL: 'TOURNAMENT_CANCEL',
  TOURNAMENT_LEVEL_CHANGE: 'TOURNAMENT_LEVEL_CHANGE',
  TOURNAMENT_INIT: 'TOURNAMENT_INIT',
  TOURNAMENT_START_HAND: 'TOURNAMENT_START_HAND',
  TOURNAMENT_PLAYER_SEATED: 'TOURNAMENT_PLAYER_SEATED',
  TOURNAMENT_PLAYER_UNSEATED: 'TOURNAMENT_PLAYER_UNSEATED',
  TOURNAMENT_TABLE_OPENED: 'TOURNAMENT_TABLE_OPENED',
  TOURNAMENT_TABLE_CLOSED: 'TOURNAMENT_TABLE_CLOSED'
} as const

export type TournamentEventType = (typeof TournamentEventType)[keyof typeof TournamentEventType]


export const RebuyAddonType = {
  REBUY: 'REBUY',
  ADDON: 'ADDON'
} as const

export type RebuyAddonType = (typeof RebuyAddonType)[keyof typeof RebuyAddonType]


export const TournamentIcon = {
  NONE: 'NONE',
  PHNM_LOGO: 'PHNM_LOGO',
  STAR_LOGO: 'STAR_LOGO',
  BOUNTY_LOGO: 'BOUNTY_LOGO',
  DIAMOND_LOGO: 'DIAMOND_LOGO',
  TICKET_LOGO: 'TICKET_LOGO',
  FREE_LOGO: 'FREE_LOGO'
} as const

export type TournamentIcon = (typeof TournamentIcon)[keyof typeof TournamentIcon]


export const TournamentColor = {
  DEFAULT_WHITE: 'DEFAULT_WHITE',
  PURPLE: 'PURPLE',
  PINK: 'PINK',
  LIGHT_BLUE: 'LIGHT_BLUE',
  LIGHT_GREEN: 'LIGHT_GREEN',
  ORANGE: 'ORANGE',
  RED: 'RED',
  YELLOW: 'YELLOW',
  WATERMELON: 'WATERMELON',
  LEMON: 'LEMON'
} as const

export type TournamentColor = (typeof TournamentColor)[keyof typeof TournamentColor]


export const TicketType = {
  TOURNAMENT: 'TOURNAMENT',
  USDT: 'USDT'
} as const

export type TicketType = (typeof TicketType)[keyof typeof TicketType]
